/**
 * Returns the final mask params
 *
 * @returns mask params
 */

import { useContext } from 'react'
import InputMaskedContext from '../InputMaskedContext'
import { useMask } from './useMask'
import { useNumberMaskParams } from './useNumberMaskParams'

export const useMaskParams = () => {
  const { props } = useContext(InputMaskedContext)

  const { showMask, placeholder } = props

  const mask = useMask()
  const maskParams = useNumberMaskParams() || {}

  maskParams.showMask = !placeholder && showMask === true

  if (typeof mask?.showMask !== 'undefined') {
    maskParams.showMask = mask.showMask
  }

  return maskParams
}
